export default "__VITE_ASSET__DQJBoKCv__"